import toast from 'react-hot-toast';

// Fire-and-forget clipboard writes swallow permission/security errors
// silently (e.g. denied clipboard-write permission, insecure context). This
// wraps navigator.clipboard.writeText so every call site surfaces success
// and failure consistently via toast.
export async function copyText(text: string): Promise<void> {
  try {
    await navigator.clipboard.writeText(text);
    toast.success('Copied');
  } catch {
    toast.error('Copy failed');
  }
}
